module.exports = __webpack_public_path__ + "img/couples-023.ed5f36ab.jpg";